export default __webpack_public_path__ + "static/media/SidhantPuntambekarResume2025-2026.da615e9a.pdf";